"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var U = __importStar(require("./utils"));
var Datepicker = function (_a) {
    var name = _a.name, data = _a.data, onChange = _a.onChange, _b = _a.format, format = _b === void 0 ? U.formatDefault : _b, id = _a.id, label = _a.label, _c = _a.shouldReturnDateObj, shouldReturnDateObj = _c === void 0 ? false : _c, _d = _a.shouldReturnDateTime, shouldReturnDateTime = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var strName = name.toString();
    var _f = react_1.useState(U.getValueFromObject(name, data, format)), value = _f[0], setValue = _f[1];
    react_1.useEffect(function () {
        setValue(U.getValueFromObject(name, data, format));
    }, [data, name, format]);
    var handleChange = function (newValueUTC) {
        setValue(newValueUTC);
        var v;
        if (newValueUTC) {
            if (shouldReturnDateObj) {
                v = newValueUTC;
            }
            else {
                if (U.isValidDate(newValueUTC)) {
                    var isoString = newValueUTC.toISOString();
                    v = shouldReturnDateTime ? isoString : isoString.substr(0, 10);
                }
                else {
                    v = newValueUTC;
                }
            }
        }
        else {
            v = '';
        }
        onChange({
            name: strName,
            value: v
        });
    };
    return (react_1["default"].createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1["default"] },
        react_1["default"].createElement(pickers_1.KeyboardDatePicker, { id: id ? id : name.toString(), label: label, variant: "inline", value: value || null, onChange: handleChange, format: format, disabled: disabled })));
};
exports["default"] = Datepicker;
